module.exports = __webpack_public_path__ + "static/media/soft_drinks.a5530cf6.svg";